import { ReviewDetail } from './ReviewDetail';
export default ReviewDetail;
